import { get } from 'underscore';
import { DirectionalHint } from '@fluentui/react';
import { TeachingBubbleConfigs as NavigationRefreshTeachingBubbleConfig } from '@bingads-webui-campaign-react/navigation-refresh-teaching-bubble-config';
import { couponTeachingBubbleConfig, couponTeachingBubbleOldUIConfig } from '@bingads-webui-cc-react/coupon-teachingbubble-loader';
import { defaultUserGovernanceConfig } from '@bingads-webui-campaign-react/multi-step-teaching-bubble';
import { PreferenceState } from '@bingads-webui-campaign-react/popup-components';
import { TeachingBubbleConfigs as InsertionOrderReportTeachingBubbleConfig } from '@bingads-webui-campaign-react/reports-v4-insertion-order-teaching-bubble-config';
import { CustomReportBuilderTeachingBubbleConfig, ReportHomePageTeachingBubbleConfig } from '@bingads-webui-campaign-react/custom-reports-page-teaching-bubble-config';
import { ReportingInsightsTeachingBubbleConfig } from '@bingads-webui-campaign-react/reporting-insights-components';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';
import { setClarityTag } from '@bingads-webui-universal/clarity';

import {
  uetTeachingBubbleUserGovernanceConfig
} from './custom-uet-teaching-bubble-governance-config';
import { ChurnModelCouponNotificationTeachingBubbleUIConfig } from './custom-churn-model-coupon-teaching-bubble-config';

const escMigrationGovernanceConfig = {
  ...defaultUserGovernanceConfig,
  [PreferenceState.INIT]: {
    ...defaultUserGovernanceConfig[PreferenceState.INIT],
    stateMachine: {
      ...defaultUserGovernanceConfig[PreferenceState.INIT].stateMachine,
      onDismiss: PreferenceState.STOP_SHOWN,
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
};
export const escMigrationTeachingBubbleFeatureName = 'smb-migration-welcome';
export const EscMigrationTeachingBubbleConfig = {
  featureName: escMigrationTeachingBubbleFeatureName,
  userGovernanceConfig: escMigrationGovernanceConfig,
  steps: [
    {
      title: _TL_('Welcome to a new and improved Microsoft Advertising experience'),
      content: _TL_('We’ve migrated your Microsoft Advertising accounts and campaigns to this new and improved experience.'),
      primaryButtonText: _TL_('Next'),
      secondaryButtonText: _TL_(''),
      targetElement: '#advertise',
      directionalHint: DirectionalHint.rightTopEdge,
    },
    {
      title: _TL_('Manage your campaigns'),
      content: _TL_('Manage all of your campaigns and assets in Campaigns. You can edit your budget by going to Campaign settings.'),
      primaryButtonText: _TL_('Next'),
      secondaryButtonText: _TL_(''),
      targetElement: '#advertise',
      directionalHint: DirectionalHint.rightTopEdge,
    },
    {
      title: _TL_('Create new campaigns'),
      content: _TL_('Create new campaigns by selecting Create.'),
      primaryButtonText: _TL_('Next'),
      secondaryButtonText: _TL_(''),
      targetElement: '#create',
      directionalHint: DirectionalHint.rightTopEdge,
    },
    {
      title: _TL_('Access reports'),
      content: _TL_('Don’t worry - you can still access your previous performance data. It just may take up to few hours to view. Note: Pre-migration data tied to conversion goals won’t be available.'),
      primaryButtonText: _TL_('Next'),
      secondaryButtonText: _TL_(''),
      targetElement: '#reports-v4',
      directionalHint: DirectionalHint.rightCenter,
    },
    {
      title: _TL_('Conversion goals'),
      content: _TL_('Review and manage your conversion goals by clicking on Tools and pinning Conversions to the menu.'),
      primaryButtonText: _TL_('Got it'),
      secondaryButtonText: _TL_(''),
      targetElement: '#allTools',
      directionalHint: DirectionalHint.rightCenter,
    },
  ],
};

export const uetConsentNotificationFeatureName = 'uet-consent-notification-teaching-bubble';
const UetConsentNotificationTeachingBubbleUIConfig =
{
  featureName: uetConsentNotificationFeatureName,
  userGovernanceConfig: uetTeachingBubbleUserGovernanceConfig,
  steps: [
    {
      title: _TL_('Action Required: Ensure proper implementation of consent signals'),
      content: _TL_('You may not have properly instrumented consent signals on your website. To avoid negative impacts on conversion attribution and remarketing for European Economic Area (EEA)-targeted campaigns, implement Consent Mode or the Transparency and Consent Framework (TCF) with your UET tags.'),
      primaryButtonText: _TL_('Set up now'),
      isSecondaryButtonHidden: true,
      targetElement: 'button.notifications-item',
      directionalHint: DirectionalHint.bottomAutoEdge,
      onNext: (_scope, _siteMap, serverContext) => {
        const languageCode = get(serverContext, ['CurrentLocale'], 'en-us').toLowerCase().split('-')[0];
        window.open(`https://help.ads.microsoft.com/apex/index/3/${languageCode}/60119`, '_blank');
      },
    },
  ],
};

export const adsStudioTeachingBubbleFeatureName = 'ads-studio-teaching-bubble';
const AdsStudioTeachingBubbleConfig =
{
  featureName: adsStudioTeachingBubbleFeatureName,
  userGovernanceConfig: defaultUserGovernanceConfig,
  steps: [
    {
      title: _TL_('Asset library upgraded to Ads Studio'),
      content: _TL_('We\'ve upgraded Asset library to the new Ads Studio experience, providing additional tools and features to help enhance your media. With Ads Studio, you can easily add, create, edit, and manage all your assets across campaigns. Get started with Ads Studio to curate compelling assets for your ads.'),
      primaryButtonText: _TL_('Get started'),
      // first condition ensured ads studio selector if no overflow
      targetElement: 'div[data-overflow-item][data-overflow-group]:not([data-overflowing]) button#asset-library, button#allTools',
      directionalHint: DirectionalHint.rightCenter,
      onNext: (_scope, _siteMap) => {
        setClarityTag({ ClickAdsStudioTeachingBubblePrimaryButton: true });
        _scope.save(getRoutePathById(_siteMap, 'ad-studio-home-page'));
      },
    },
  ],
};

export const configs = [
  EscMigrationTeachingBubbleConfig,
  NavigationRefreshTeachingBubbleConfig,
  couponTeachingBubbleConfig,
  couponTeachingBubbleOldUIConfig,
  InsertionOrderReportTeachingBubbleConfig,
  ReportingInsightsTeachingBubbleConfig,
  CustomReportBuilderTeachingBubbleConfig,
  ReportHomePageTeachingBubbleConfig,
  UetConsentNotificationTeachingBubbleUIConfig,
  ChurnModelCouponNotificationTeachingBubbleUIConfig,
  AdsStudioTeachingBubbleConfig,
];
